import { Grid, Card, CardActionArea, CardContent, Stack, Typography } from '@mui/material';
import { reservationTimeSlot as styles } from './reservation-time-slot/reservation-time-slot.styles';

type SlotCardProps = {
  slot: { start: string; end: string };
  isSelected: boolean;
  onSlotClick: (slot: { start: string; end: string }) => void;
};

export const TimeSlot = ({ slot, isSelected, onSlotClick }: SlotCardProps) => (
  <Grid size={{ xs: 6, sm: 6, md: 4 }}>
    <Card sx={styles.root(isSelected)}>
      <CardActionArea onClick={() => onSlotClick(slot)}>
        <CardContent sx={styles.content}>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography variant="h6" color="primary" fontWeight="bold">
              {slot.start}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              -
            </Typography>
            <Typography variant="h6" color="primary" fontWeight="bold">
              {slot.end}
            </Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  </Grid>
);
